/**
 * Groups deleted during this session (by the user, or announced over realtime). Deleting a group also revokes its
 * realtime topic; a page that is still on screen while it navigates away must not refetch the gone group then.
 */
const deleted = new Set<string>();

export const markGroupDeleted = (groupId: string) => {
  deleted.add(groupId);
};

export const unmarkGroupDeleted = (groupId: string) => {
  deleted.delete(groupId);
};

export const isGroupDeleted = (groupId: string) => deleted.has(groupId);
